import React from "react";
import Testimonial from "../../Components/Testimonials/Testimonials";
import data from "../../data.json";
import How from "../../Components/How/How";
import ServicesSection from "../../Components/ServicesSection/ServicesSection";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import CoreBusiness from "../../Components/CoreBusiness/CoreBusiness";
import FadeInWhenVisible from "../../Utilities/FadeInWhenVisible";

export default function ServicesPage() {
  return (
    <div>
      <HeaderBanner title="Services" currentPath="Services" />
      <FadeInWhenVisible delay={0.2}>
        <ServicesSection />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <How />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <CoreBusiness />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <Testimonial testimonialData={data} />
      </FadeInWhenVisible>
    </div>
  );
}
